import { apiSlice, asyncToastDisplay, i18n } from "./apiSlice";

export const dataVendorAwsCredsApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getDataVendorAwsCreds: builder.query({
      query: (dataVendorId) => `/data_vendors/${dataVendorId}/aws_credentials`,
      providesTags: (result = [], error, arg) => [
        {type: 'AwsCreds', id: arg},
      ]
    }),
    createDataVendorAwsCred: builder.mutation({
      query: ([dataVendorId, userId]) => ({
        url: `/data_vendors/${dataVendorId}/aws_credentials`,
        method: 'POST',
        body: { userId: userId }
      }),
      onQueryStarted: asyncToastDisplay({successMessage: i18n.t("toast.created")}),
      invalidatesTags: (result = [], error, [dataVendorId,]) => [{ type: 'AwsCreds', id: dataVendorId }],
    }),
    deleteDataVendorAwsCred: builder.mutation({
      query: ([dataVendorId, id]) => ({
        url: `/data_vendors/${dataVendorId}/aws_credentials/${id}`,
        method: 'DELETE'
      }),
      onQueryStarted: asyncToastDisplay({successMessage: i18n.t("toast.deleted")}),
      invalidatesTags: (result = [], error, [dataVendorId,]) => [{ type: 'AwsCreds', id: dataVendorId }],
    })
  }),
  overrideExisting: false
})

export const {
  useGetDataVendorAwsCredsQuery,
  useCreateDataVendorAwsCredMutation,
  useDeleteDataVendorAwsCredMutation
} = dataVendorAwsCredsApiSlice
